import React from 'react';
import { StatusTag } from '../../common';
import ImageGrid from './ImageGrid';

function SpaceGallery({ title, images, alt, getImageUrl }) {
    return (
        <div className="rounded-xl border border-surface-200">
            <div className="flex items-center justify-between px-4 py-3 border-b border-surface-100">
                <span className="text-sm font-semibold text-surface-900">{title}</span>
                <StatusTag tone="neutral" className="tabular-nums">
                    {images.length}
                </StatusTag>
            </div>
            <div className="p-4">
                <ImageGrid images={images} getImageUrl={getImageUrl} alt={alt} height={100} columns="grid-cols-2 sm:grid-cols-3" />
            </div>
        </div>
    );
}

/** "Espacios Adicionales": our / their extra exhibition spaces, shown only when there are photos. */
export default function AdditionalSpaces({ ourSpaces = [], theirSpaces = [], getImageUrl }) {
    if (ourSpaces.length === 0 && theirSpaces.length === 0) return null;

    return (
        <div className="mt-6 pt-6 border-t border-surface-100">
            <h3 className="m-0 mb-4 text-sm font-semibold text-surface-900">Espacios Adicionales</h3>
            <div className="grid gap-4 grid-cols-1 md:grid-cols-2">
                {ourSpaces.length > 0 && <SpaceGallery title="Nuestros Espacios" images={ourSpaces} alt="Nuestro espacio" getImageUrl={getImageUrl} />}
                {theirSpaces.length > 0 && <SpaceGallery title="Sus Espacios" images={theirSpaces} alt="Su espacio" getImageUrl={getImageUrl} />}
            </div>
        </div>
    );
}
